import { selectorTabbable } from './settings.js';

/**
 * @param Base The base class.
 * @returns A mix-in implementing `.focus()` method that focuses on the first focusable element in the shadow DOM.
 */
export const FocusMixin = Base =>
  class extends Base {
    /**
     * Focuses on the first focusable element in the shadow DOM.
     */
    focus() {
      if (this.shadowRoot && this.shadowRoot.delegatesFocus) {
        super.focus();
      } else {
        const delegateTarget =
          (this.shadowRoot && this.shadowRoot.querySelector(selectorTabbable)) ||
          this.querySelector(selectorTabbable);
        if (delegateTarget) {
          delegateTarget.focus();
        } else {
          super.focus();
        }
      }
    }

    hasVisibleFocusInTree() {
      const { activeElement } = this.getRootNode();
      if (!activeElement) {
        return false;
      }
      try {
        return activeElement.matches(':focus-visible') || activeElement.matches('.focus-visible');
      } catch (error) {
        console.error(error);
        return activeElement.matches('.focus-visible');
      }
    }
  };

export default FocusMixin;
